import { render } from "./Proveedor_Editar_Cliente.vue?vue&type=template&id=71264dfa"
import script from "./Proveedor_Editar_Cliente.vue?vue&type=script&lang=js"
export * from "./Proveedor_Editar_Cliente.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__